export const ROTATE_HANDLE_CORNER = "rotate";

const toNumber = (value) => Number(value) || 0;

export const normalizeRotation = (value) => {
  const deg = toNumber(value);
  const wrapped = ((deg % 360) + 360) % 360;
  return wrapped > 180 ? wrapped - 360 : wrapped;
};

export const formatRotationDegreesLabel = (rotation) =>
  `${Math.round(normalizeRotation(rotation))}°`;

export const boxCenter = ({ x, y, width, height }) => ({
  x: toNumber(x) + toNumber(width) / 2,
  y: toNumber(y) + toNumber(height) / 2,
});

export const rotatePoint = ({ point, center, degrees }) => {
  const rad = (toNumber(degrees) * Math.PI) / 180;
  const cos = Math.cos(rad);
  const sin = Math.sin(rad);
  const dx = toNumber(point?.x) - toNumber(center?.x);
  const dy = toNumber(point?.y) - toNumber(center?.y);
  return {
    x: toNumber(center?.x) + dx * cos - dy * sin,
    y: toNumber(center?.y) + dx * sin + dy * cos,
  };
};

export const unrotatePoint = ({ point, center, degrees }) =>
  rotatePoint({ point, center, degrees: -toNumber(degrees) });

export const pointInRotatedBox = ({ point, box }) => {
  const x = toNumber(box?.x);
  const y = toNumber(box?.y);
  const width = toNumber(box?.width);
  const height = toNumber(box?.height);
  const rotation = toNumber(box?.rotation);
  if (!width || !height) return false;
  const local = rotation
    ? unrotatePoint({
        point,
        center: boxCenter({ x, y, width, height }),
        degrees: rotation,
      })
    : point;
  return (
    local.x >= x &&
    local.x <= x + width &&
    local.y >= y &&
    local.y <= y + height
  );
};

export const rotationDegreesFromDrag = ({
  center,
  startPoint,
  currentPoint,
  originRotation = 0,
}) => {
  const startAngle = Math.atan2(
    toNumber(startPoint?.y) - toNumber(center?.y),
    toNumber(startPoint?.x) - toNumber(center?.x)
  );
  const currentAngle = Math.atan2(
    toNumber(currentPoint?.y) - toNumber(center?.y),
    toNumber(currentPoint?.x) - toNumber(center?.x)
  );
  return normalizeRotation(
    toNumber(originRotation) + ((currentAngle - startAngle) * 180) / Math.PI
  );
};

export const cssRotateTransform = (rotation) => {
  const deg = toNumber(rotation);
  return deg ? `rotate(${deg}deg)` : "none";
};

export const applyCanvasRotation = (context, box) => {
  const rotation = toNumber(box?.rotation);
  if (!rotation) return;
  const center = boxCenter(box);
  context.translate(center.x, center.y);
  context.rotate((rotation * Math.PI) / 180);
  context.translate(-center.x, -center.y);
};
